import type { QueryClient } from "@tanstack/react-query";
import ServiceDeskAPIService from "@sd/services/APIs";
import {
  serviceDeskAdminTicketDetailQueryKey,
  serviceDeskTicketCreateDetailQueryKey,
  serviceDeskTicketHistoryQueryKey,
  serviceDeskTicketCreateListQueryKey,
} from "@sd/services/APIs";
import { statusToApiValue } from "@sd/constants/ticketStatuses";

/** PATCH `/service_desk/ticket_create/{id}/` — ticket_create API fields only. */
export async function patchTicketCreate(
  queryClient: QueryClient,
  ticketId: string,
  fields: Record<string, unknown>
): Promise<boolean> {
  // Backend expects dashes in status values (e.g. `in-progress`, not `in_progress`).
  const payload =
    fields.status !== undefined && fields.status !== null
      ? { ...fields, status: statusToApiValue(fields.status) }
      : fields;

  const response = await ServiceDeskAPIService.tickets.patchCreatedTicket(
    ticketId,
    payload
  );
  if (
    !response ||
    response.status < 200 ||
    response.status >= 300
  ) {
    return false;
  }

  void queryClient.invalidateQueries({
    queryKey: serviceDeskTicketCreateListQueryKey,
  });
  void queryClient.invalidateQueries({
    queryKey: serviceDeskAdminTicketDetailQueryKey(ticketId),
  });
  void queryClient.invalidateQueries({
    queryKey: serviceDeskTicketCreateDetailQueryKey(ticketId),
  });
  void queryClient.invalidateQueries({
    queryKey: serviceDeskTicketHistoryQueryKey(ticketId),
  });

  return true;
}
